module.exports = "module.exports = \"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PGcgc3Ryb2tlPSIjQkRCRkMxIiBzdHJva2Utd2lkdGg9IjIiPjxwYXRoIGQ9Ik00IDIzTDE4LjUzOCA5LjM3YTIuMTYgMi4xNiAwIDAgMSAyLjkyNCAwTDM2IDIzbS03LTEyVjUuOTljMC0uNTQ2LjQ1LS45OS45OS0uOTloNC4wMmMuNTQ2IDAgLjk5LjQ0NS45OS45OTZWMTYiLz48cGF0aCBmaWxsPSIjRkZGIiBkPSJNMTYgMjRoOHYxMmgtOHoiLz48cGF0aCBkPSJNOSAyNXYxMS41MU0zMSAyNC41djExLjUxIi8+PC9nPjwvZz48L3N2Zz4=\""


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./images/repairs/roofing.svg
 ** module id = 3594
 ** module chunks = 3
 **/